import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type BackupJob } from '../../api/resilience';

export function BackupCenterPage() {
  const [backups, setBackups] = useState<BackupJob[]>([]);
  const refresh = () => void resilienceApi.listBackups().then(setBackups);
  useEffect(() => { refresh(); }, []);
  const trigger = async (type: string) => { await resilienceApi.createBackup({ resource_type: type, mode: 'full' }); refresh(); };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Backup Center</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <div className="mt-4 flex flex-wrap gap-2">
        {['postgresql', 'redis', 'object_storage', 'configuration', 'documents', 'knowledge'].map((t) => (
          <button key={t} type="button" onClick={() => trigger(t)} className="rounded bg-emerald-600 px-3 py-1.5 text-sm text-white hover:bg-emerald-700">{t}</button>
        ))}
      </div>
      <div className="mt-6 overflow-x-auto rounded-xl border dark:border-slate-700">
        <table className="min-w-full text-sm"><thead className="bg-slate-50 dark:bg-slate-800"><tr><th className="px-4 py-2 text-left">Resource</th><th className="px-4 py-2 text-left">Mode</th><th className="px-4 py-2 text-left">Status</th><th className="px-4 py-2 text-left">Size</th><th className="px-4 py-2 text-left">Encrypted</th></tr></thead>
          <tbody>{backups.map((b) => (<tr key={b.id} className="border-t dark:border-slate-700"><td className="px-4 py-2">{b.resource_type}</td><td className="px-4 py-2">{b.mode}</td><td className="px-4 py-2">{b.status}</td><td className="px-4 py-2">{(b.size_bytes / 1024 / 1024).toFixed(1)} MB</td><td className="px-4 py-2">{b.encrypted ? 'Yes' : 'No'}</td></tr>))}</tbody>
        </table>
      </div>
    </div>
  );
}
